import React from 'react';
import { useNavigate } from 'react-router-dom';
import {useDispatch, useSelector} from "react-redux";
import {selectRoleRequest} from "../../redux/actions/authenticationActions";
import {FormSelect} from "react-bootstrap";

const RoleSelector = ({ userGroups }) => {
    const dispatch = useDispatch();
    const selectedRole = useSelector(state => state.authentication.selectedRole);
    const navigate = useNavigate();

    const handleRoleSelection = (event) => {
        localStorage.setItem('selectedRole', event.target.value);
        dispatch(selectRoleRequest({ selectedRole: event.target.value }));
    };

    const handleRoleConfirm = () => {
        switch (selectedRole) {
            case 'staffmembers':
                navigate('/mdb/staff');
                break;
            case 'humanressource':
                navigate('/mdb/hr');
                break;
            case 'institute':
            case 'assistant':
                navigate('/mdb/institute');
                break;
            case 'rectorate':
                navigate('/mdb/rectorate');
                break;
            case 'school':
                navigate('/mdb/school');
                break;
            case 'federalstate':
                navigate('/mdb/federalstate');
                break;
            case 'admin':
                navigate('/mdb/admin');
                break;
            default:
                console.log('Keine gültige Rolle ausgewählt');
        }
    };

    return (
        <div style={{ marginTop: '50px' }}>
            <h3>Rolle auswählen</h3>
            <div className="form-group">
                <FormSelect
                    className="form-control"
                    value={selectedRole || ''}
                    onChange={handleRoleSelection}
                >
                    <option value="" disabled>Wählen Sie eine Rolle aus</option>
                    {userGroups.map((group) => (
                        <option key={group} value={group}>
                            {
                                group === 'staffmembers' ? 'Mitarbeiter' :
                                group === 'humanressource' ? 'Personal' :
                                group === 'institute' ? 'Institut' :
                                group === 'assistant' ? 'Assistent' :
                                group === 'rectorate' ? 'Rektorat' :
                                group === 'school' ? 'Schule' :
                                group === 'federalstate' ? 'Bildungsdirektion' :
                                group === 'admin' ? 'Admin' : group
                            }
                        </option>
                    ))}
                </FormSelect>
            </div>
            <button
                className="btn btn-primary mt-2"
                onClick={handleRoleConfirm}
                disabled={!selectedRole}
            >
                Bestätigen
            </button>
        </div>
    );
};

export default RoleSelector;
